import React from "react";
import { CONNECTION_GAME } from "../../lib/data";

export const PuzzleDataContext = React.createContext();

function PuzzleDataProvider({ children }) {
  const [gameData, setGameData] = React.useState(CONNECTION_GAME);
  const categorySize = gameData[0].words.length;
  const numCategories = gameData.length;
  return (
    <PuzzleDataContext.Provider
      value={{ gameData, numCategories, categorySize }}
    >
      {children}
    </PuzzleDataContext.Provider>
  );
}

export default PuzzleDataProvider;
